import { generatePath } from 'react-router-dom';
import { RouteSegments } from '../routingClientAdmin.interface';
import { withOptionalDetailsId } from './withOptionalDetailsId';

export const generateLpSymbolsRoute = (lpId: number, symbolName?: string) => {
  return generatePath(
    withOptionalDetailsId(`/${RouteSegments.Root.Config}/${RouteSegments.Lps.Symbols}`),
    { lpId: String(lpId), id: symbolName },
  );
};
